import Dexie from 'dexie';
let db = new Dexie('ecommerce_db');

// Define a schema
// db.version(1).stores({ property: "++id, catalog"})
db.version(1).stores({ errors: "++id, date, time, modul, code, error"})
db.version(1).stores({ posts: "++id, pid, sku, name, image, attributes, outletid, weight, weighttot, outlet, qty, price, discount, taxval, tax, user, total"})
db.open().catch((err) => { console.log(err);})

export default db;